<div>   
  <div class="row" style="justify-content: center;">

      <button class="routing-btn"
        [ngClass]="{'currentTab':showAccountSettings===true ,'otherTab':showAccountSettings===false}"
        (click)="showAccountSettings=true">{{'COUPON.TITLE' | translate}}</button>
      <!-- <button class="routing-btn"
        [ngClass]="{'currentTab':showAccountSettings===false ,'otherTab':showAccountSettings===true}"
        (click)="showAccountSettings=false">{{'COUPON.VIEWING_COUPON' | translate}}</button> -->
     
    </div>
    <div class="content-payment">
    <app-coupon-redemption *ngIf="showAccountSettings"></app-coupon-redemption>
    <app-viewing-coupons *ngIf="!showAccountSettings"></app-viewing-coupons>
    </div>

</div>
